(() => {
/* Paste the image URLs for the option buttons here. */
    const optionImages = {
      shape: {
        maverick: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/1_6c47b932-8b17-4a69-bfaf-1e484394e133.png?v=1781984333",
        Shark: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/2_06f005e2-2873-44cb-a34e-49361828aa53.png?v=1781984333",
        "The-Tank": "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/3_0ba0142a-8ba6-4f42-821f-1c1543ae3e35.png?v=1781984333",
        blade: ""
      },
      wood: {
        walnut: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/Walnut_136a8c9f-7f95-4e80-aabb-dadd877b071b.png?v=1778608848",
        "maple": "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/Curly_Maple.png?v=1778608851",
        purpleheart: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/Purple_Heart.png?v=1778608848",
        Padauk: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/ChatGPT_Image_Jun_25_2026_02_06_51_PM.png?v=1782410868"
      }
    };

    const mediaAssets = {
      /*
        Face Grooves preview images are selected by Body Material, then groove style.
        Add each image URL to the matching material/style below.
        `default` is used when a material-specific image is unavailable.
      */
      faceGrooves: {
        walnut: {
          Classic: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/Classic-Walnut.png?v=1782326825",
          Precision: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/Maple_-_Grooves.png?v=1787493259"
        },
        maple: {
          Classic: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/Classic_Maple.png?v=1782326823",
          Precision: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/Shark_-_Grooves.png?v=1787007294"
        },
        purpleheart: {
          Classic: "",
          Precision: ""
        },
        Padauk: {
          Classic: "",
          Precision: ""
        },
        default: {
          Classic: "",
          Precision: ""
        }
      },
      grip: {
        Thin: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/Thin.png?v=1782319426",
        Medium: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/Midsize.png?v=1782319427",
        "Thick (+$20)": "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/SuperStroke.png?v=1782319426",
        "Custom [URL] (+$30)": "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/Custom.png?v=1782319427"
      },
      /*
        Add engraving preview image URLs below.
        `default` is the Shape + Body fallback image.
        A populated format key overrides it when that engraving format is selected.
      */
      engraving: {
        maverick: {
          walnut: { default: "", "your-edition": "", "1-of-1": "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/1of1-Walnut_f6c8b340-a1de-409c-9830-30b18808f305.png?v=1785181474", signature: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/Signature-Walnut_05f3046e-bca5-46a0-a2ff-e8767e3b6c6f.png?v=1785181473", "three-putt": "" },
          maple: { default: "", "your-edition": "", "1-of-1": "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/1of1-Maple_7a3ff9e9-a3dd-4bf7-ad36-0c62c890c0eb.png?v=1785181472", signature: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/Signature-Maple_1.png?v=1787491154", "three-putt": "" },
          purpleheart: { default: "", "your-edition": "", "1-of-1": "", signature: "", "three-putt": "" },
          Padauk: { default: "", "your-edition": "", "1-of-1": "", signature: "", "three-putt": "" }
        },
        Shark: {
          walnut: { default: "", "your-edition": "", "1-of-1": "", signature: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/Signature-Walnut.png?v=1785178731", "built-for": "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/Built_For-Walnut.png?v=1785178731" },
          maple: { default: "", "your-edition": "", "1-of-1": "", signature: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/Signature-Maple_f061f6e6-28cf-4140-8e36-af09f7d5d142.png?v=1785178730", "built-for": "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/Built_For-Maple.png?v=1785178730" },
          purpleheart: { default: "", "your-edition": "", "1-of-1": "", signature: "", "three-putt": "" },
          Padauk: { default: "", "your-edition": "", "1-of-1": "", signature: "", "three-putt": "" }
        },
        "The-Tank": {
          walnut: { default: "", "your-edition": "", "1-of-1": "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/1of1-Walnut.png?v=1785174916", signature: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/Siganture-Walnut.png?v=1785174913", "three-putt": "" },
          maple: { default: "", "your-edition": "", "1-of-1": "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/Signature-Maple.png?v=1785174916", signature: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/Signature-Maple.png?v=1785174916", "three-putt": "" },
          purpleheart: { default: "", "your-edition": "", "1-of-1": "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/1of1-Purpleheart.png?v=1785177637", signature: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/Signature-Purpleheart.png?v=1785177636", "three-putt": "" },
          Padauk: { default: "", "your-edition": "", "1-of-1": "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/1of1-Paduak.png?v=1785177637", signature: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/Signature-Paduak.png?v=1785177637", "three-putt": "" }
        },
        blade: {
          walnut: { default: "", "your-edition": "", "1-of-1": "", signature: "", "three-putt": "" },
          maple: { default: "", "your-edition": "", "1-of-1": "", signature: "", "three-putt": "" },
          purpleheart: { default: "", "your-edition": "", "1-of-1": "", signature: "", "three-putt": "" },
          Padauk: { default: "", "your-edition": "", "1-of-1": "", signature: "", "three-putt": "" }
        }
      }
    };

    /*
      Position the live engraving over "Your Name Here".
      x/y/width are percentages of the image. largeY controls the enlarged
      square independently; when omitted, it defaults to 9% above y.
      fontSize uses container units so the text scales at every size.
    */
    const engravingTextLayout = {
      maverick: {
        default: {
          signature: { x: 50, y: 55, largeY: 46, width: 56, fontSize: 9.2, lineHeight: .92, fontFamily: "'Great Vibes', 'Brush Script MT', 'Segoe Script', 'Snell Roundhand', cursive", fontWeight: 700, color: "#1d130c", shadow: "0 .5px .6px rgba(0, 0, 0, .45)" },
          "1-of-1": { x: 50, y: 57, largeY: 48, width: 62, fontSize: 5.6, lineHeight: 1.04, fontFamily: 'Arial, Helvetica, sans-serif', fontWeight: 800, color: "#1d130c" }
        },
        maple: {
          signature: { color: "#4a2814" },
          "1-of-1": { color: "#4a2814" }
        },
        purpleheart: {
          signature: { color: "#160b10" },
          "1-of-1": { color: "#160b10" }
        },
        Padauk: {
          signature: { color: "#24100a" },
          "1-of-1": { color: "#24100a" }
        }
      },
      Shark: {
        default: {
          "built-for": { x: 72, y: 45, largeY: 45, width: 24, fontSize: 3.8, lineHeight: 1.05, fontFamily: "Georgia, 'Times New Roman', serif", fontWeight: 500, color: "#1d130c" },
          signature: { x: 70, y: 49, largeY: 49, width: 28, fontSize: 5.5, lineHeight: .96, fontFamily: "'Great Vibes', 'Brush Script MT', 'Segoe Script', 'Snell Roundhand', cursive", fontWeight: 700, color: "#1d130c", shadow: "0 .5px .6px rgba(0, 0, 0, .45)" }
        },
        maple: {
          "built-for": { color: "#4a2814" },
          signature: { color: "#4a2814" }
        },
        purpleheart: {
          "built-for": { color: "#160b10" },
          signature: { color: "#160b10" }
        },
        Padauk: {
          "built-for": { color: "#24100a" },
          signature: { color: "#24100a" }
        }
      },
      "The-Tank": {
        default: {
          signature: { x: 62, y: 51, largeY: 51, width: 25, fontSize: 4.37, lineHeight: .98, fontFamily: "'Great Vibes', 'Brush Script MT', 'Segoe Script', 'Snell Roundhand', cursive", fontWeight: 700, color: "#1d130c", shadow: "0 .5px .6px rgba(0, 0, 0, .45)" },
          "1-of-1": { x: 62, y: 51, largeY: 51, width: 25, fontSize: 3.11, lineHeight: 1.05, fontFamily: 'Arial, Helvetica, sans-serif', fontWeight: 800, color: "#1d130c" }
        },
        maple: {
          signature: { color: "#4a2814" },
          "1-of-1": { color: "#4a2814" }
        },
        purpleheart: {
          signature: { color: "#160b10" },
          "1-of-1": { color: "#160b10" }
        },
        Padauk: {
          signature: { color: "#24100a" },
          "1-of-1": { color: "#24100a" }
        }
      },
      blade: {
        default: {
          signature: { x: 50, y: 57, largeY: 48, width: 66, fontSize: 7, fontFamily: "'Great Vibes', 'Brush Script MT', 'Segoe Script', 'Snell Roundhand', cursive", fontWeight: 700, color: "#1d130c", shadow: "0 .5px .6px rgba(0, 0, 0, .45)" },
          "1-of-1": { x: 50, y: 57, largeY: 48, width: 66, fontSize: 5.4, fontFamily: 'Arial, Helvetica, sans-serif', fontWeight: 800, color: "#1d130c" }
        }
      }
    };

    /* Paste the transparent render overlay URLs here. Each shape has its own overlay set. */
    const layerMap = {
      maverick: {
        shape: "",
        body: { walnut: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/Maverick_-_Builder_Assets_3.png?v=1785121501", "maple": "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/2_24c97be6-ff64-47b9-ad32-1805ab715913.png?v=1785121047", purpleheart: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/M-Purple-B.png?v=1778704166", Padauk: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/M-Purple-B.png?v=1778704166" },
        alignment: { walnut: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/A-W_de48aed4-0373-4b8a-a4a2-ca59b8c8aa01.png?v=1785121041", "maple": "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/A-M_20dc6c15-58c7-4eb8-9c91-989f6492b2a5.png?v=1785121041", purpleheart: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/A-PH_583edb3a-347a-4d51-8b39-edd12c667189.png?v=1787490962", Padauk: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/A-P_5ea5c0a9-b1b0-4d3c-88c0-c7b35ce81109.png?v=1785121042" },
        secondary: { walnut: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/S-W_ea2825fc-2e25-4b00-a097-6d213c2245a2.png?v=1785121041", "maple": "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/S-M_43b8f7a9-4526-4003-a66d-f8e3ddc84c52.png?v=1787490843", purpleheart: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/S-PH_2d730c6b-3747-4754-898b-44ba61031224.png?v=1785121041", Padauk: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/S-P_6711d2c1-73de-4b6e-856f-594d48a545e1.png?v=1785121041" }
      },
      Shark: {
        shape: "",
        body: { walnut: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/Body-Walnut_1.png?v=1785110389", "maple": "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/Body-Walnut_2_502c670d-0347-42fd-9e4b-ca5bf8abeddc.png?v=1785112491", purpleheart: "", Padauk: "" },
        alignment: { walnut: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/A-W.png?v=1785103549", "maple": "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/A-M.png?v=1785103550", purpleheart: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/A-PH_033f4109-be64-4578-a70b-f8884df0f36e.png?v=1785112718", Padauk: "" },
        secondary: { walnut: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/S-W_ba419a94-fafc-4476-a753-6c1a9303b9a4.png?v=1785106112", "maple": "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/S-M_66b84001-3003-406c-8c47-a736e1cd9d43.png?v=1785106112", purpleheart: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/S-PH_55287e8e-d4b1-43e9-9f3c-104046568d92.png?v=1785112718", Padauk: "" }
      },
      "The-Tank": {
        shape: "",
        body: { walnut: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/Walnut-T.png?v=1785118080", "maple": "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/Walnut-T_2.png?v=1785118078", purpleheart: "", Padauk: "" },
        alignment: { walnut: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/A-W_c3a5ebf7-7ed3-440b-80a8-860d372ae807.png?v=1785118074", "maple": "", purpleheart: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/A-PH_4ed0003c-c2c0-4db1-ad2f-3a407d6dd02d.png?v=1785118074", Padauk: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/A-P_72c2302a-f058-45ec-8bbc-c687ca315c4f.png?v=1785118074" },
        secondary: { walnut: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/S-W_6631b4b5-64ca-4f13-a863-fd451c8aac78.png?v=1785118074", "maple": "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/S-M_0143f571-76cd-4371-92cb-66a89121dab3.png?v=1785118074", purpleheart: "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/S-PH_caec87b3-6509-4dda-bb3c-a3b449e16a8a.png?v=1785118074", Padauk: "" }
      },
      blade: {
        shape: "",
        body: { walnut: "", "maple": "", purpleheart: "", Padauk: "" },
        alignment: { walnut: "", "maple": "", purpleheart: "", Padauk: "" },
        secondary: { walnut: "", "maple": "", purpleheart: "", Padauk: "" }
      }
    };

    /* Edit these arrays to control which options are available for each shape. */
    const shapeAvailability = {
      maverick: {
        body: ["walnut", "maple", "Padauk"],
        alignment: ["walnut", "maple", "purpleheart", "Padauk"],
        secondary: ["walnut", "maple", "purpleheart", "Padauk"]
      },
      Shark: {
        body: ["walnut", "maple", "purpleheart", "Padauk"],
        alignment: ["walnut", "maple", "purpleheart", "Padauk"],
        secondary: ["walnut", "maple", "purpleheart", "Padauk"]
      },
      "The-Tank": {
        body: ["walnut", "maple", "purpleheart", "Padauk"],
        alignment: ["walnut", "maple", "purpleheart", "Padauk"],
        secondary: ["walnut", "maple", "purpleheart", "Padauk"]
      },
      blade: {
        body: ["walnut", "maple", "purpleheart", "Padauk"],
        alignment: ["walnut", "maple", "purpleheart", "Padauk"],
        secondary: ["walnut", "maple", "purpleheart", "Padauk"]
      }
    };

    const root = document.getElementById("workshop");
    if (!root || root.dataset.workshopInitialized === "true") return;
    root.dataset.workshopInitialized = "true";
    const loaderLogoUrl = "https://cdn.shopify.com/s/files/1/0709/5137/0861/files/Logo_-white-x2_1.png?v=1785687194";
    if (!document.querySelector('link[data-workshop-font="great-vibes"]')) {
      const fontLink = document.createElement("link");
      fontLink.rel = "stylesheet";
      fontLink.href = "https://fonts.googleapis.com/css2?family=Great+Vibes&display=swap";
      fontLink.dataset.workshopFont = "great-vibes";
      document.head.appendChild(fontLink);
    }
    const render = root.querySelector("[data-render]");
    const mainPanelAlt = root.querySelector("[data-main-panel-alt]");
    const mainBackground = root.querySelector("[data-main-background]");
    const discountModal = root.querySelector("[data-discount-modal]");
    const videoModal = root.querySelector("[data-video-modal]");
    const putterVideo = root.querySelector("[data-putter-video]");
    const discountStorageKey = "workshopDiscountPopupSeen";
    const mediaState = {
      main: "render",
      thumbs: ["faceGrooves", "grip", "engraving"]
    };
    const layers = {
      shape: root.querySelector('[data-layer="shape"]'),
      body: root.querySelector('[data-layer="body"]'),
      alignment: root.querySelector('[data-layer="alignment"]'),
      secondary: root.querySelector('[data-layer="secondary"]')
    };
    let renderLoadToken = 0;
    const labels = {
      maverick: "Maverick",
      Shark: "The Shark",
      "The-Tank": "The Tank",
      blade: "Blade",
      walnut: "Walnut",
      "maple": "Maple",
      purpleheart: "Purpleheart",
      Padauk: "Padauk"
    };
    const state = {
      shape: "The-Tank",
      body: "walnut",
      alignment: "maple",
      secondary: "purpleheart",
      grip: "Medium",
      hand: "Right",
      shaft: '36"',
      lie: '70°',
      faceGrooves: "Classic",
      engravingFormat: "signature",
      customGripUrl: "",
      engraving: ""
    };
    const builderPages = Array.from(root.querySelectorAll("[data-builder-page]"));
    const builderPrevious = root.querySelector("[data-builder-previous]");
    const builderNext = root.querySelector("[data-builder-next]");
    const builderStepButtons = Array.from(root.querySelectorAll("[data-builder-step]"));
    const builderPageLabels = ["The Design", "The Specs", "Personalize"];
    let activeBuilderPage = 0;
    const validValues = {
      shape: ["maverick", "Shark", "The-Tank", "blade"],
      body: ["walnut", "maple", "purpleheart", "Padauk"],
      alignment: ["walnut", "maple", "purpleheart", "Padauk"],
      secondary: ["walnut", "maple", "purpleheart", "Padauk"],
      grip: ["Thin", "Medium", "Thick (+$20)", "Custom [URL] (+$30)"],
      hand: ["Right", "Left"],
      shaft: ['32"', '33"', '34"', '35"', '36"', '37"', '38"'],
      faceGrooves: ["Classic", "Precision"],
      engravingFormat: ["signature", "1-of-1", "built-for"],
      lie: ['65°','68°','70°','72°','75°']
      
    };
    const shapeBasePrices = {
      maverick: { price: 385, variantId: "variant_385" },
      Shark: { price: 315, variantId: "variant_315" },
      "The-Tank": { price: 295, variantId: "variant_295" },
      blade: { price: 365, variantId: "" }
    };
    /*
      Shopify checkout can only charge real Shopify variant prices.
      Create builder product variants for each possible final total, then paste
      their numeric variant IDs below. Shipping is calculated by Shopify checkout.
    */
    const shopifyCheckout = {
      variantIdsByPrice: {
        295: "variant_295",
        300: "variant_300",
        305: "variant_305",
        310: "variant_310",
        315: "variant_315",
        320: "variant_320",
        325: "variant_325",
        330: "variant_330",
        340: "variant_340",
        345: "variant_345",
        350: "variant_350",
        355: "variant_355",
        360: "variant_360",
        365: "variant_365",
        385: "variant_385",
        395: "variant_395",
        405: "variant_405",
        410: "variant_410",
        415: "variant_415",
        420: "variant_420",
        425: "variant_425",
        430: "variant_430",
        435: "variant_435",
        440: "variant_440",
        445: "variant_445",
        450: "variant_450",
        455: "variant_455",
        460: "variant_460",
        465: "variant_465",
        470: "variant_470",
        475: "variant_475",
        480: "variant_480",
        485: "variant_485",
        490: "variant_490",
        495: "variant_495",
        500: "variant_500"
      },
      cartAddUrl: "/cart/add.js",
      cartUrl: "/cart",
      checkoutUrl: "/checkout"
    };
    Object.keys(shopifyCheckout.variantIdsByPrice).forEach((price) => {
      shopifyCheckout.variantIdsByPrice[price] = root.getAttribute(`data-variant-${price}`) || shopifyCheckout.variantIdsByPrice[price];
    });
    const skuCodes = {
      shape: { maverick: "M", Shark: "S", "The-Tank": "T"},
      body: { walnut: "W", "maple": "M"},
      alignment: { walnut: "W", "maple": "M", purpleheart: "H", Padauk: "P" },
      secondary: { walnut: "W", "maple": "M", purpleheart: "H", Padauk: "P" },
      grip: { Thin: "T", Medium: "M", "Thick (+$20)": "S", "Custom [URL] (+$30)": "C" },
      hand: { Right: "R", Left: "L" },
      faceGrooves: { Classic: "C", Precision: "P" },
      engravingFormat: { signature: "S", "1-of-1": "1", "built-for": "B" }
    };
    const engravingOptionsByShape = {
      maverick: [
        { value: "signature", label: "Signature Edition" },
        { value: "1-of-1", label: "1 of 1" }
      ],
      Shark: [
        { value: "built-for", label: "Built for" },
        { value: "signature", label: "Signature Edition" }
      ],
      "The-Tank": [
        { value: "signature", label: "Signature Edition" },
        { value: "1-of-1", label: "1 of 1" }
      ],
      blade: [
        { value: "signature", label: "Signature Edition" },
        { value: "1-of-1", label: "1 of 1" }
      ]
    };
    const engravingPrice = 20;
    const gripPrices = {
      "Thick (+$20)": 20,
      "Custom [URL] (+$30)": 30
    };

    function getObjectValue(path, source) {
      return path.split(".").reduce((value, key) => value?.[key], source);
    }

    function isCustomGripSelected() {
      return state.grip === "Custom [URL] (+$30)";
    }

    function isValidCustomGripUrl(value) {
      try {
        const url = new URL(value.trim());
        return (url.protocol === "https:" || url.protocol === "http:") && Boolean(url.hostname);
      } catch {
        return false;
      }
    }

    function syncCustomGripUi(showError = false) {
      const field = root.querySelector("[data-custom-grip-field]");
      const input = root.querySelector("[data-custom-grip-url]");
      const error = root.querySelector("[data-custom-grip-error]");
      const isCustom = isCustomGripSelected();
      const isValid = !isCustom || isValidCustomGripUrl(state.customGripUrl);

      field.hidden = !isCustom;
      input.required = isCustom;
      input.value = state.customGripUrl;
      input.setAttribute("aria-invalid", String(isCustom && !isValid));

      if (!isCustom || isValid) {
        error.textContent = "";
      } else if (showError || state.customGripUrl) {
        error.textContent = "Enter a valid http(s) URL to an in-stock grip before purchasing.";
      } else {
        error.textContent = "A URL to an in-stock grip is required.";
      }

      root.querySelectorAll("[data-purchase-action]").forEach((button) => {
        button.disabled = !isValid;
        button.setAttribute("aria-disabled", String(!isValid));
        button.title = isValid ? "" : "Enter a valid in-stock custom grip URL first.";
      });
      return isValid;
    }

    function escapeHtml(value) {
      return String(value).replace(/[&<>"']/g, (char) => ({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      })[char]);
    }

    function engravingLines() {
      const text = state.engraving || "[engraving]";
      const formats = {
        signature: [text],
        "1-of-1": ["Handcrafted for", text, "1 of 1"],
        "built-for": ["Built for", text]
      };
      return formats[state.engravingFormat] || formats.signature;
    }

    function formatEngravingHtml() {
      return engravingLines().map((line) => escapeHtml(line)).join("<br>");
    }

    function formatEngravingText() {
      return engravingLines().filter((line) => line !== "").join(" / ");
    }

    function engravingPreviewConfig() {
      const engravingImageKey = state.shape === "The-Tank" ? state.alignment : state.body;
      const asset = mediaAssets.engraving[state.shape]?.[engravingImageKey];
      const image = typeof asset === "string"
        ? asset
        : asset?.[state.engravingFormat] || asset?.default || asset?.["your-edition"] || asset?.["1-of-1"] || "";
      const shapeLayout = engravingTextLayout[state.shape] || {};
      const defaultLayout = shapeLayout.default?.[state.engravingFormat] || {};
      const materialLayout = shapeLayout[state.body]?.[state.engravingFormat] || {};
      const layout = { ...defaultLayout, ...materialLayout };
      return {
        image,
        x: Number(layout.x ?? 50),
        y: Number(layout.y ?? 57),
        largeY: Number(layout.largeY ?? (Number(layout.y ?? 57) - 9)),
        width: Number(layout.width ?? 66),
        fontSize: Number(layout.fontSize ?? 5.4),
        lineHeight: Number(layout.lineHeight ?? 1.05),
        fontFamily: layout.fontFamily || 'Arial, Helvetica, sans-serif',
        fontWeight: layout.fontWeight || 800,
        fontStyle: layout.fontStyle || "normal",
        letterSpacing: layout.letterSpacing || "0",
        color: "#000",
        shadow: layout.shadow || "0 1px 1px rgba(255, 255, 255, .2)"
      };
    }

    function faceGroovesImage() {
      const assets = mediaAssets.faceGrooves;
      const materialAssets = assets[state.body];
      if (typeof materialAssets === "string") return materialAssets;
      if (materialAssets?.[state.faceGrooves]) return materialAssets[state.faceGrooves];
      if (typeof assets[state.faceGrooves] === "string") return assets[state.faceGrooves];
      return materialAssets?.Classic || assets.default?.[state.faceGrooves] || assets.default?.Classic || "";
    }

    function hydrateOptionImages() {
      const emptyImage = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
      root.querySelectorAll("[data-thumb]").forEach((image) => {
        const src = getObjectValue(image.dataset.thumb, optionImages);
        if (src) {
          image.src = src;
          image.classList.remove("is-empty-thumb");
        } else {
          image.src = emptyImage;
          image.classList.add("is-empty-thumb");
        }
      });
    }

    function mediaPanelHtml(type) {
      const emptyImage = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
      if (type === "render") {
        return `<div class="render-clone" aria-hidden="true">${render.innerHTML}</div>`;
      }
      if (type === "faceGrooves") {
        const src = faceGroovesImage() || emptyImage;
        return `<div class="media-panel"><img src="${src}" alt=""><span class="media-panel__title">Face Grooves</span></div>`;
      }
      if (type === "grip") {
        const src = mediaAssets.grip[state.grip] || emptyImage;
        return `<div class="media-panel"><img src="${src}" alt=""><span class="media-panel__title">Grip</span></div>`;
      }
      if (type === "engraving") {
        const preview = engravingPreviewConfig();
        const src = preview.image || emptyImage;
        const style = [
          `--engraving-x:${preview.x}%`,
          `--engraving-y:${preview.y}%`,
          `--engraving-large-y:${preview.largeY}%`,
          `--engraving-width:${preview.width}%`,
          `--engraving-font-size:${preview.fontSize}cqw`,
          `--engraving-line-height:${preview.lineHeight}`,
          `--engraving-font-family:${preview.fontFamily}`,
          `--engraving-font-weight:${preview.fontWeight}`,
          `--engraving-font-style:${preview.fontStyle}`,
          `--engraving-letter-spacing:${preview.letterSpacing}`,
          `--engraving-color:${preview.color}`,
          `--engraving-shadow:${preview.shadow}`
        ].join(";");
        const text = escapeHtml(state.engraving || "Your Name Here");
        return `<div class="media-panel"><img src="${src}" alt=""><span class="media-panel__title">Engraving</span><span class="media-panel__engraving" style="${style}">${text}</span></div>`;
      }
      return "";
    }

    function mediaPanelTitle(type) {
      return {
        render: "Design Mockup",
        faceGrooves: "Face Grooves",
        grip: "Selected Grip",
        engraving: "Engraving Mockup"
      }[type] || "";
    }

    function renderMediaPanels() {
      const isRenderMain = mediaState.main === "render";
      render.hidden = !isRenderMain;
      mainPanelAlt.hidden = isRenderMain;
      if (!isRenderMain) {
        mainPanelAlt.innerHTML = mediaPanelHtml(mediaState.main);
      } else {
        mainPanelAlt.replaceChildren();
      }

      root.querySelectorAll("[data-gallery-index]").forEach((button, index) => {
        const panelType = mediaState.thumbs[index];
        const title = mediaPanelTitle(panelType);
        button.innerHTML = mediaPanelHtml(panelType);
        if (title) button.insertAdjacentHTML("beforeend", `<span class="gallery__title">${escapeHtml(title)}</span>`);
        button.setAttribute("aria-label", `Use ${title || panelType} as main image`);
      });
      syncFloatingPreview();
    }

    function selectMediaType(type) {
      if (mediaState.main === type) return;
      const thumbIndex = mediaState.thumbs.indexOf(type);
      if (thumbIndex === -1) return;
      mediaState.thumbs[thumbIndex] = mediaState.main;
      mediaState.main = type;
    }

    function availableValues(option) {
      return shapeAvailability[state.shape]?.[option] || validValues[option];
    }

    function availableEngravingFormats() {
      return engravingOptionsByShape[state.shape] || engravingOptionsByShape.maverick;
    }

    function applyEngravingOptions() {
      const select = root.querySelector('[data-select="engravingFormat"]');
      if (!select) return;
      const options = availableEngravingFormats();
      if (!options.some((option) => option.value === state.engravingFormat)) {
        state.engravingFormat = options[0]?.value || "signature";
      }
      select.replaceChildren(...options.map((option) => {
        const item = document.createElement("option");
        item.value = option.value;
        item.textContent = option.label;
        item.selected = option.value === state.engravingFormat;
        return item;
      }));
    }

    function applyShapeAvailability() {
      ["body", "alignment", "secondary"].forEach((option) => {
        const allowed = availableValues(option);
        root.querySelectorAll(`input[name="${option}"]`).forEach((input) => {
          const isAvailable = allowed.includes(input.value);
          input.disabled = !isAvailable;
          input.closest(".choice").hidden = !isAvailable;
        });

        if (!allowed.includes(state[option])) {
          state[option] = allowed[0] || "";
        }

        const selected = Array.from(root.querySelectorAll(`input[name="${option}"]`)).find((input) => input.value === state[option]);
        if (selected) selected.checked = true;
      });
      applyEngravingOptions();
    }

    function readStateFromUrl() {
      const params = new URLSearchParams(window.location.search);
      Object.keys(validValues).forEach((key) => {
        const value = params.get(key);
        if (value && validValues[key].includes(value)) {
          state[key] = value;
        }
      });
      state.engraving = (params.get("engraving") || "").slice(0, 40);
      state.customGripUrl = (params.get("customGripUrl") || "").slice(0, 2048);
    }

    function syncControlsFromState() {
      ["shape", "body", "alignment", "secondary"].forEach((key) => {
        const input = Array.from(root.querySelectorAll(`input[name="${key}"]`)).find((option) => option.value === state[key]);
        if (input) input.checked = true;
      });
      applyEngravingOptions();

      const gripSelect = root.querySelector('[data-select="grip"]');
      const shaftSelect = root.querySelector('[data-select="shaft"]');
      const lieSelect = root.querySelector('[data-select="lie"]');
      const faceGroovesSelect = root.querySelector('[data-select="faceGrooves"]');
      const engravingFormatSelect = root.querySelector('[data-select="engravingFormat"]');
      const engravingInput = root.querySelector("[data-engraving]");
      const customGripInput = root.querySelector("[data-custom-grip-url]");
      const handInput = Array.from(root.querySelectorAll('input[name="hand"]')).find((option) => option.value === state.hand);
      gripSelect.value = state.grip;
      shaftSelect.value = state.shaft;
      lieSelect.value = state.lie;
      faceGroovesSelect.value = state.faceGrooves;
      engravingFormatSelect.value = state.engravingFormat;
      engravingInput.value = state.engraving;
      customGripInput.value = state.customGripUrl;
      if (handInput) handInput.checked = true;
      syncCustomGripUi();
    }

    function updateUrl() {
      const url = new URL(window.location.href);
      Object.keys(validValues).forEach((key) => {
        url.searchParams.set(key, state[key]);
      });
      url.searchParams.delete("loft");
      if (state.engraving) {
        url.searchParams.set("engraving", state.engraving);
      } else {
        url.searchParams.delete("engraving");
      }
      if (state.customGripUrl) {
        url.searchParams.set("customGripUrl", state.customGripUrl);
      } else {
        url.searchParams.delete("customGripUrl");
      }
      window.history.replaceState({}, "", url);
    }

    function updatePrice() {
      const basePrice = shapeBasePrices[state.shape]?.price || 0;
      const price = basePrice + (state.engraving ? engravingPrice : 0) + (gripPrices[state.grip] || 0);
      root.querySelector("[data-price]").textContent = `$${price}`;
      return price;
    }

    function buildSku() {
      const engraving = state.engraving.trim().replace(/[^a-z0-9]/gi, "").slice(0, 40);
      const baseSku = [
        `${skuCodes.shape[state.shape] || state.shape}${skuCodes.body[state.body] || state.body}`,
        skuCodes.alignment[state.alignment] || state.alignment,
        skuCodes.secondary[state.secondary] || state.secondary,
        skuCodes.grip[state.grip] || state.grip,
        skuCodes.hand[state.hand] || state.hand,
        state.shaft.replace(/[^0-9]/g, ""),
        state.lie.replace(/[^0-9]/g, ""),
        skuCodes.faceGrooves[state.faceGrooves] || state.faceGrooves,
        skuCodes.engravingFormat[state.engravingFormat] || state.engravingFormat
      ].join("");
      return engraving ? `${baseSku}-${engraving}` : baseSku;
    }

    function shareMessage() {
      return "Check out this putter I designed!";
    }

    async function copyDesignLink(link) {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(link);
        return true;
      }

      const input = document.createElement("textarea");
      input.value = link;
      input.setAttribute("readonly", "");
      input.style.position = "fixed";
      input.style.opacity = "0";
      document.body.appendChild(input);
      input.select();
      const copied = document.execCommand("copy");
      input.remove();
      return copied;
    }

    async function shareDesign() {
      updateUrl();
      const link = window.location.href;
      const message = shareMessage();
      const isMobile = window.matchMedia("(max-width: 749px)").matches;

      if (isMobile && navigator.share) {
        try {
          await navigator.share({ text: message, url: link });
          setCheckoutStatus("Design ready to share.");
          return;
        } catch (error) {
          if (error?.name === "AbortError") return;
        }
      }

      try {
        await copyDesignLink(link);
        setCheckoutStatus("Design link copied to clipboard.");
      } catch {
        setCheckoutStatus("Copy this design link from your browser address bar.", true);
      }

      if (!isMobile) {
        const subject = encodeURIComponent("Custom putter design");
        const body = encodeURIComponent(`${message}\n\n${link}`);
        window.location.href = `mailto:?subject=${subject}&body=${body}`;
      }
    }

    function selectionProperties(price, sku) {
      return {
        "SKU": sku,
        "Shape": labels[state.shape],
        "Body Material": labels[state.body],
        "Alignment Inlay": labels[state.alignment],
        "Secondary Inlay": labels[state.secondary],
        "Grip": state.grip,
        "Custom Grip URL": isCustomGripSelected() ? state.customGripUrl : "",
        "Hand": state.hand,
        "Shaft Length": state.shaft,
        "Lie": state.lie,
        "Face Grooves": state.faceGrooves,
        "Engraving Format": state.engravingFormat,
        "Engraving Text": state.engraving || "None"
      };
    }

    function configuredVariantId(price) {
      return shopifyCheckout.variantIdsByPrice[price] || shapeBasePrices[state.shape]?.variantId || "";
    }

    function normalizeVariantId(value) {
      const raw = String(value || "").trim();
      if (/^\d+$/.test(raw)) return raw;
      const gidMatch = raw.match(/ProductVariant\/(\d+)/i);
      if (gidMatch) return gidMatch[1];
      const variantParam = raw.match(/[?&]variant=(\d+)/i);
      if (variantParam) return variantParam[1];
      const trailingNumber = raw.match(/(\d+)(?:\D*)$/);
      return trailingNumber ? trailingNumber[1] : "";
    }

    function setCheckoutStatus(message, isError = false) {
      const status = root.querySelector("[data-checkout-status]");
      if (!status) return;
      status.textContent = message;
      status.hidden = !message;
      status.classList.toggle("is-error", Boolean(isError));
    }

    function setPurchaseLoading(isLoading) {
      root.querySelectorAll("[data-purchase-action]").forEach((button) => {
        button.disabled = isLoading;
        button.setAttribute("aria-busy", String(isLoading));
      });
    }

    async function addBuildToShopify(action) {
      if (!syncCustomGripUi(true)) {
        root.querySelector("[data-custom-grip-url]").focus();
        return;
      }

      const { price, sku } = syncShopifyFields();
      const variantId = normalizeVariantId(configuredVariantId(price));
      if (!variantId) {
        setCheckoutStatus(`Checkout is not configured for the $${price} build total. Add the matching Shopify variant ID in this section's settings.`, true);
        return;
      }

      setPurchaseLoading(true);
      setCheckoutStatus(action === "buy" ? "Preparing secure checkout..." : "Adding your custom putter to cart...");

      try {
        const response = await fetch(shopifyCheckout.cartAddUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: selectionProperties(price, sku)
          })
        });

        if (!response.ok) {
          const details = await response.json().catch(() => ({}));
          throw new Error(details.description || details.message || "Shopify could not add this build to cart.");
        }

        window.location.href = action === "buy" ? shopifyCheckout.checkoutUrl : shopifyCheckout.cartUrl;
      } catch (error) {
        setCheckoutStatus(error.message || "Something went wrong while adding this build. Please try again.", true);
        setPurchaseLoading(false);
      }
    }

    function syncShopifyFields() {
      const price = updatePrice();
      const sku = buildSku();
      const selections = selectionProperties(price, sku);
      root.querySelector("[data-shopify-variant-id]").value = normalizeVariantId(configuredVariantId(price));
      root.querySelector("[data-shopify-sku]").value = sku;
      root.querySelector("[data-shopify-price]").value = price;
      root.querySelector("[data-shopify-selections]").value = JSON.stringify(selections);
      root.querySelector("[data-shopify-custom-grip-url]").value = isCustomGripSelected() ? state.customGripUrl : "";
      return { price, sku };
    }

    function preloadImage(src) {
      if (!src) return Promise.resolve();
      return new Promise((resolve) => {
        const image = new Image();
        image.onload = () => {
          if (typeof image.decode !== "function") {
            resolve();
            return;
          }
          image.decode().catch(() => {}).finally(resolve);
        };
        image.onerror = resolve;
        image.src = src;
      });
    }

    function uniqueUrls(urls) {
      return [...new Set(urls.filter(Boolean))];
    }

    function currentRenderLayerSources() {
      const currentShape = layerMap[state.shape] || {};
      return {
        shape: currentShape.shape || "",
        body: currentShape.body?.[state.body] || "",
        alignment: currentShape.alignment?.[state.alignment] || "",
        secondary: currentShape.secondary?.[state.secondary] || ""
      };
    }

    function initialVisibleAssetUrls() {
      const optionThumbs = [...root.querySelectorAll("[data-thumb]")]
        .map((image) => getObjectValue(image.dataset.thumb, optionImages));
      const engravingPreview = engravingPreviewConfig();
      return uniqueUrls([
        loaderLogoUrl,
        ...optionThumbs,
        ...Object.values(currentRenderLayerSources()),
        faceGroovesImage(),
        mediaAssets.grip[state.grip],
        engravingPreview.image
      ]);
    }

    function preloadInitialVisibleAssets() {
      return Promise.all(initialVisibleAssetUrls().map(preloadImage));
    }

    function releasePageLoader() {
      root.classList.remove("is-page-loading");
      root.setAttribute("data-page-loaded", "true");
    }

    function preloadRenderLayers(nextLayers) {
      return Promise.all(Object.values(nextLayers).map(preloadImage));
    }

    function currentMediaPanelSources() {
      return uniqueUrls([
        faceGroovesImage(),
        mediaAssets.grip[state.grip],
        engravingPreviewConfig().image
      ]);
    }

    function preloadMediaPanels() {
      return Promise.all(currentMediaPanelSources().map(preloadImage));
    }

    function setRenderLoading(isLoading) {
      render.classList.toggle("is-loading", isLoading);
      root.classList.toggle("is-render-loading", isLoading);
      render.setAttribute("aria-busy", String(isLoading));
    }

    function updateRenderLayerSources(nextLayers) {
      Object.entries(nextLayers).forEach(([name, src]) => {
        layers[name].src = src || "";
      });
    }

    function applyLayers() {
      syncCustomGripUi();
      const nextLayers = currentRenderLayerSources();
      const token = ++renderLoadToken;
      setRenderLoading(true);
      root.querySelector("[data-summary-title]").textContent = `${labels[state.shape]}: ${labels[state.body]} w/ ${labels[state.alignment]} & ${labels[state.secondary]}`;
      const shopify = syncShopifyFields();
      root.querySelector("[data-summary-meta]").textContent = `Grip: ${state.grip}, Face Grooves: ${state.faceGrooves}, Hand: ${state.hand}, Engraving: ${state.engraving ? formatEngravingText() : "None"}`;
      return Promise.all([
        preloadRenderLayers(nextLayers),
        preloadMediaPanels()
      ]).then(() => {
        if (token !== renderLoadToken) return;
        updateRenderLayerSources(nextLayers);
        return new Promise((resolve) => requestAnimationFrame(() => {
          if (token !== renderLoadToken) {
            resolve();
            return;
          }
          setRenderLoading(false);
          renderMediaPanels();
          syncFloatingPreview();
          updateFloatingVisibility();
          resolve();
        }));
      });
    }

    function cloneRender() {
      const clone = document.createElement("div");
      clone.className = "render-clone";
      if (render.classList.contains("is-loading")) clone.classList.add("is-loading");
      clone.setAttribute("aria-hidden", "true");
      clone.innerHTML = render.innerHTML;
      return clone;
    }

    function cloneActivePanel() {
      if (mediaState.main === "render") return cloneRender();
      const clone = document.createElement("div");
      clone.className = "render-clone";
      clone.setAttribute("aria-hidden", "true");
      clone.innerHTML = mediaPanelHtml(mediaState.main);
      return clone;
    }

    function syncFloatingPreview() {
      root.querySelector("[data-floating-image]").replaceChildren(cloneActivePanel());
      const modal = root.querySelector("[data-preview-modal]");
      if (modal.getAttribute("aria-hidden") === "false") {
        root.querySelector("[data-preview-stage]").replaceChildren(cloneActivePanel());
      }
    }

    function updateFloatingVisibility() {
      const activePanel = mediaState.main === "render" ? render : mainPanelAlt;
      root.classList.toggle("is-render-past", activePanel.getBoundingClientRect().bottom < 0);
    }

    function openDiscountModal() {
      if (!discountModal) return;
      discountModal.setAttribute("aria-hidden", "false");
      document.documentElement.style.overflow = "hidden";
      root.querySelector("[data-discount-email]")?.focus();
    }

    function closeDiscountModal() {
      if (!discountModal) return;
      discountModal.setAttribute("aria-hidden", "true");
      document.documentElement.style.overflow = "";
    }

    function scheduleDiscountModal() {
      if (!discountModal || sessionStorage.getItem(discountStorageKey) === "true") return;
      window.setTimeout(() => {
        if (sessionStorage.getItem(discountStorageKey) === "true") return;
        sessionStorage.setItem(discountStorageKey, "true");
        openDiscountModal();
      }, 20000);
    }

    function setBuilderPage(index, shouldFocus = false) {
      if (!builderPages.length) return;
      activeBuilderPage = Math.max(0, Math.min(index, builderPages.length - 1));
      builderPages.forEach((page, pageIndex) => {
        page.hidden = pageIndex !== activeBuilderPage;
      });

      if (builderPrevious) {
        const isFirstPage = activeBuilderPage === 0;
        builderPrevious.disabled = isFirstPage;
        builderPrevious.classList.toggle("button--primary", !isFirstPage);
        builderPrevious.textContent = isFirstPage
          ? "Current: " + builderPageLabels[activeBuilderPage]
          : "Previous: " + builderPageLabels[activeBuilderPage - 1];
      }
      if (builderNext) {
        const isLastPage = activeBuilderPage === builderPages.length - 1;
        builderNext.disabled = isLastPage;
        builderNext.classList.toggle("button--primary", !isLastPage);
        builderNext.textContent = isLastPage
          ? "Current: " + builderPageLabels[activeBuilderPage]
          : "Next: " + builderPageLabels[activeBuilderPage + 1];
      }
      builderStepButtons.forEach((button, pageIndex) => {
        const isActive = pageIndex === activeBuilderPage;
        button.classList.toggle("is-complete", pageIndex < activeBuilderPage);
        if (isActive) button.setAttribute("aria-current", "step");
        else button.removeAttribute("aria-current");
      });

      if (shouldFocus) {
        builderPages[activeBuilderPage].querySelector(".builder-page__title")?.focus();
      }
    }

    function swapGalleryImage(index) {
      const nextMain = mediaState.thumbs[index];
      if (!nextMain) return;
      mediaState.thumbs[index] = mediaState.main;
      mediaState.main = nextMain;
      renderMediaPanels();
      updateFloatingVisibility();
    }

    root.addEventListener("change", (event) => {
      const input = event.target;
      if (input.matches('input[type="radio"][data-option]')) {
        state[input.dataset.option] = input.value;
        if (input.dataset.option === "shape") {
          applyShapeAvailability();
        }
        selectMediaType("render");
        updateUrl();
        applyLayers();
      }
      if (input.matches('[data-select="grip"]')) {
        state.grip = input.value;
        selectMediaType("grip");
        updateUrl();
        applyLayers();
      }
      if (input.matches('[data-select="shaft"]')) {
        state.shaft = input.value;
        updateUrl();
      }
      if (input.matches('[data-select="lie"]')) {
        state.lie = input.value;
        updateUrl();
      }
      if (input.matches('[data-select="faceGrooves"]')) {
        state.faceGrooves = input.value;
        selectMediaType("faceGrooves");
        updateUrl();
        applyLayers();
      }
      if (input.matches('[data-select="engravingFormat"]')) {
        state.engravingFormat = input.value;
        selectMediaType("engraving");
        updateUrl();
        applyLayers();
      }
      if (input.matches('[data-simple-option="hand"]')) {
        state.hand = input.value;
        updateUrl();
        applyLayers();
      }
    });

    root.addEventListener("input", (event) => {
      const input = event.target;
      if (input.matches("[data-custom-grip-url]")) {
        state.customGripUrl = input.value.trim().slice(0, 2048);
        updateUrl();
        syncCustomGripUi(true);
        syncShopifyFields();
      }
      if (input.matches("[data-engraving]")) {
        input.value = input.value.slice(0, 40);
        state.engraving = input.value;
        selectMediaType("engraving");
        updateUrl();
        applyLayers();
      }
    });

    root.addEventListener("click", async (event) => {
      const stepButton = event.target.closest("[data-builder-step]");
      if (stepButton) {
        event.preventDefault();
        setBuilderPage(Number(stepButton.dataset.builderStep), true);
        return;
      }

      const previousPageButton = event.target.closest("[data-builder-previous]");
      if (previousPageButton) {
        event.preventDefault();
        setBuilderPage(activeBuilderPage - 1, true);
        return;
      }

      const nextPageButton = event.target.closest("[data-builder-next]");
      if (nextPageButton) {
        event.preventDefault();
        setBuilderPage(activeBuilderPage + 1, true);
        return;
      }

      const discountOpen = event.target.closest("[data-open-discount]");
      if (discountOpen) {
        event.preventDefault();
        openDiscountModal();
        return;
      }

      const discountClose = event.target.closest("[data-close-discount]");
      if (discountClose) {
        event.preventDefault();
        closeDiscountModal();
        return;
      }

      const shareButton = event.target.closest("[data-share-design]");
      if (shareButton) {
        event.preventDefault();
        await shareDesign();
        return;
      }

      const purchaseButton = event.target.closest("[data-purchase-action]");
      if (purchaseButton) {
        event.preventDefault();
        await addBuildToShopify(purchaseButton.dataset.purchaseAction);
        return;
      }

      const infoTrigger = event.target.closest("[data-info-trigger]");
      if (infoTrigger) {
        const wrap = infoTrigger.closest(".info-wrap");
        const willOpen = !wrap.classList.contains("is-open");
        root.querySelectorAll(".info-wrap.is-open").forEach((item) => {
          item.classList.remove("is-open");
          item.querySelector("[data-info-trigger]").setAttribute("aria-expanded", "false");
        });
        wrap.classList.toggle("is-open", willOpen);
        infoTrigger.setAttribute("aria-expanded", String(willOpen));
        return;
      }

      root.querySelectorAll(".info-wrap.is-open").forEach((item) => {
        item.classList.remove("is-open");
        item.querySelector("[data-info-trigger]").setAttribute("aria-expanded", "false");
      });

      const galleryButton = event.target.closest("[data-gallery-index]");
      if (!galleryButton) return;
      swapGalleryImage(Number(galleryButton.dataset.galleryIndex));
    });

    root.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") return;
      closeDiscountModal();
      closeVideoModal();
      root.querySelectorAll(".info-wrap.is-open").forEach((item) => {
        item.classList.remove("is-open");
        item.querySelector("[data-info-trigger]").setAttribute("aria-expanded", "false");
      });
    });

    function openPreview() {
      const modal = root.querySelector("[data-preview-modal]");
      modal.querySelector("[data-preview-stage]").replaceChildren(cloneActivePanel());
      modal.setAttribute("aria-hidden", "false");
      document.documentElement.style.overflow = "hidden";
    }

    function closePreview() {
      root.querySelector("[data-preview-modal]").setAttribute("aria-hidden", "true");
      document.documentElement.style.overflow = "";
    }

    function openVideoModal() {
      if (!videoModal) return;
      videoModal.setAttribute("aria-hidden", "false");
      document.documentElement.style.overflow = "hidden";
      putterVideo?.play().catch(() => {});
    }

    function closeVideoModal() {
      if (!videoModal) return;
      putterVideo?.pause();
      videoModal.setAttribute("aria-hidden", "true");
      document.documentElement.style.overflow = "";
    }

    render.addEventListener("click", openPreview);
    mainPanelAlt.addEventListener("click", openPreview);
    root.querySelectorAll("[data-gallery-index]").forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        swapGalleryImage(Number(button.dataset.galleryIndex));
      });
    });
    root.querySelector("[data-floating-preview]").addEventListener("click", openPreview);
    root.querySelector("[data-preview-close]").addEventListener("click", closePreview);
    root.querySelector("[data-preview-modal]").addEventListener("click", (event) => {
      if (event.target.matches("[data-preview-modal]")) closePreview();
    });
    root.querySelector("[data-video-trigger]")?.addEventListener("click", openVideoModal);
    root.querySelector("[data-video-close]")?.addEventListener("click", closeVideoModal);
    videoModal?.addEventListener("click", (event) => {
      if (event.target.matches("[data-video-modal]")) closeVideoModal();
    });
    discountModal?.addEventListener("click", (event) => {
      if (event.target.matches("[data-discount-modal]")) closeDiscountModal();
    });

    window.addEventListener("scroll", updateFloatingVisibility, { passive: true });
    window.addEventListener("resize", updateFloatingVisibility);

    hydrateOptionImages();
    setBuilderPage(0);
    readStateFromUrl();
    applyShapeAvailability();
    syncControlsFromState();
    updateUrl();
    const firstRender = applyLayers();
    updateFloatingVisibility();
    Promise.all([firstRender, preloadInitialVisibleAssets()])
      .then(() => requestAnimationFrame(() => {
        releasePageLoader();
        if (root.querySelector("[data-discount-response]")) {
          openDiscountModal();
        } else {
          scheduleDiscountModal();
        }
      }))
      .catch(() => requestAnimationFrame(() => {
        releasePageLoader();
        if (root.querySelector("[data-discount-response]")) {
          openDiscountModal();
        } else {
          scheduleDiscountModal();
        }
      }));
})();
